export default __webpack_public_path__ + "static/media/medicine-4.43637a43.png";